export default __webpack_public_path__ + "static/img/attractiveness.ebf8ea0.png";